import React, { useEffect, useState } from 'react'
import { format } from 'date-fns'

import {
  message, Badge, Table, Spin, PageHeader, Divider, Row, Col, Button, Tooltip, Modal,
} from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'

import { fetch } from '../../utils/fetch'

import MasterSiteModal from '../component/MasterSiteModal'

import MasterSiteFilter from './component/MasterSiteFilter'

const { Column } = Table

const MasterSite = ({ name }) => {
  const [masterSiteDataList, setMasterSiteDataList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [editItem, setEditItem] = useState(false)
  const [queryParameter, setQueryParameter] = useState(null)

  const getDataMasterSite = (query) => {
    setIsLoading(true)
    fetch({
      url: '/master-data/master-site',
      query,
    }).then((res) => {
      if (res.data?.success) {
        setMasterSiteDataList(res.data?.data)
      } else {
        setMasterSiteDataList([])
        message.error(res.message)
      }
      setIsLoading(false)
    })
  }

  const deleteMasterSite = (values) => {
    fetch({
      method: 'DELETE',
      url: `/master-data/master-site/${values.siteCode}`,
    }).then((res) => {
      if (res?.data?.success) {
        message.success('Deleted Success')
        getDataMasterSite(queryParameter)
      } else {
        message.error(res?.data?.message)
      }
    })
  }

  useEffect(() => {
    getDataMasterSite()
  }, [])

  const onSearch = (query) => {
    setQueryParameter(query)
    getDataMasterSite(query)
  }

  const onSuccess = () => {
    setVisible(false)
    setEditItem(null)
    getDataMasterSite()
  }

  const onCancel = () => {
    setVisible(false)
    setEditItem(null)
  }

  const showConfirmDelete = (values) => {
    const { confirm } = Modal
    confirm({
      title: 'Confirm Delete Site',
      content: `Are you sure to delete site : ${values.siteCode} - ${values.siteDescr}?`,
      okText: 'Yes',
      okButtonProps: {
        text: 'Yes',
      },
      cancelButtonProps: {
        cancelText: 'No',
      },
      onOk() {
        deleteMasterSite(values)
      },
    })
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={name}
          extra={(
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setVisible(true)
              }}
            >New
            </Button>
          )}
        >
          <Row gutter={24}>
            <Col xs={24} md={24}>
              <MasterSiteFilter onSearch={onSearch} />
            </Col>
          </Row>
          <Divider />
          <Table dataSource={masterSiteDataList} size="small">
            <Column title="Site Code" dataIndex="siteCode" key="siteCode" width={50} />
            <Column title="Site Description" dataIndex="siteDescr" key="siteDescr" width={100} ellipsis />
            <Column title="Active" dataIndex="isActive" key="isActive" width={50} align="center" render={(text) => (text ? <Badge status="success" /> : <Badge status="error" />)} />
            <Column title="Created At" dataIndex="createdAt" key="createdAt" width={100} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm:ss')} />
            <Column
              title="Action"
              key="action"
              width={100}
              align="center"
              render={(text, record) => {
                return (
                  <>
                    <Tooltip
                      title="Edit"
                    >
                      <Button
                        type="secondary"
                        shape="circle"
                        icon={<EditOutlined />}
                        onClick={() => {
                          setEditItem(record)
                          setVisible(true)
                        }}
                      />
                    </Tooltip>
                    <Divider type="vertical" />
                    <Tooltip
                      title="Delete"
                    >
                      <Button
                        danger
                        shape="circle"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                          showConfirmDelete(record)
                        }}
                      />
                    </Tooltip>
                  </>
                )
              }}
            />
          </Table>
        </PageHeader>
        <MasterSiteModal
          visible={visible}
          onSuccess={onSuccess}
          onCancel={onCancel}
          editItem={editItem}
        />
      </Spin>
    </>

  )
}

export default MasterSite
